import React from 'react'
import { ListChart } from '../../components'
import * as CommonStyled from '../../Visualisation.styled'
import * as Styled from './ThemeRankChart.styled'

type Props = {
  data?: { count: number; name: string }[]
}

const ThemeRankChart: React.FC<Props> = ({ data }) => (
  <Styled.Container>
    <ListChart data={data} />
    <Styled.Description>
      <CommonStyled.Title>
        Какие <CommonStyled.Underline>тематики</CommonStyled.Underline> выбирают для таргетинга
      </CommonStyled.Title>
      <p>Показываем какие тематики чаще всего выбирают рекламодатели в&nbsp;выбранной тематике</p>
    </Styled.Description>
  </Styled.Container>
)

export default ThemeRankChart
